import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Modal, Text, ColorV2 } from "@adoptaunabuelo/react-components";
import { Auth, ErrorScheme } from "client-v2";

const MainContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
	width: 100%;
	justify-content: flex-start;
	background: ${ColorV2.surface.background};
	overflow: hidden;
`;

const MobileButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: left;
	width: 100%;
	justify-content: flex-start;
`;

const ClickableText = styled.div<{ $isActive: boolean }>`
	cursor: pointer;
	margin: 0px;
	background-color: ${({ $isActive }) =>
		$isActive ? ColorV2.surface.invert : ColorV2.transparent};
	border-radius: var(--radius-L, 12px);
`;

const StyledHr = styled.hr`
	border: none;
	border-top: 1px solid ${ColorV2.text.neutralSoft};
	margin: 16px 0;
`;

function Homepage(props: Props) {
	const navigate = useNavigate();
	const location = useLocation();

	const selectedTab: "Mayores" | "Cartas" =
		location.pathname === "/cartas" ? "Cartas" : "Mayores";

	const TAB_ROUTES = {
		Mayores: "/abuelos",
		Cartas: "/cartas",
	} as const;

	const handleTabClick = (tab: keyof typeof TAB_ROUTES) => {
		const route = TAB_ROUTES[tab];
		if (location.pathname !== route) navigate(route);
	};

	const handleLogout = async () => {
		try {
			await Auth.logout({ auth: undefined });
		} catch (error) {
			console.error((error as ErrorScheme).message);
		} finally {
			navigate("/login");
		}
	};

	return (
		<Modal
			type="lateral"
			hideHeader={true}
			isVisible={props.isModalOpen}
			shouldCloseOnOverlayClick={true}
			style={{ backgroundColor: ColorV2.surface.background }}
			onClose={props.closeModal}
		>
			<MainContainer>
				<MobileButtonContainer>
					<Text
						type="h3"
						weight="semibold"
						style={{
							color: ColorV2.text.neutralHard,
							marginBottom: "24px",
							marginLeft: "16px",
						}}
					>
						{props.residenceName}
					</Text>

					<ClickableText
						onClick={() => handleTabClick("Mayores")}
						$isActive={selectedTab === "Mayores"}
					>
						<Text
							type="h5"
							weight="medium"
							style={{
								marginBottom: "11px",
								marginTop: "11px",
								marginLeft: "16px",
								color: ColorV2.text.neutralHard,
							}}
						>
							Mayores
						</Text>
					</ClickableText>
					{/* 
					<ClickableText
						onClick={() => handleTabClick("Cartas")}
						$isActive={selectedTab === "Cartas"}
					>
						<Text
							type="h5"
							weight="medium"
							style={{
								marginBottom: "11px",
								marginTop: "11px",
								marginLeft: "16px",
								color: ColorV2.text.neutralHard,
							}}
						>
							Cartas
						</Text>
					</ClickableText>
					 */}
					<StyledHr />

					<ClickableText $isActive={false}>
						<Text
							type="p"
							weight="medium"
							style={{
								marginTop: "12px",
								marginLeft: "16px",
								color: ColorV2.text.neutralHard,
							}}
							onClick={handleLogout}
						>
							Cerrar sesión
						</Text>
					</ClickableText>
				</MobileButtonContainer>
			</MainContainer>
		</Modal>
	);
}

interface Props {
	isModalOpen: boolean;
	closeModal: () => void;
	residenceName?: string;
}

export default Homepage;
